<template>
  <div>
    <p class="lead mb-1">
      <span>{{ action.node_data.question }}</span>
    </p>
    <b-button
      class="mb-1"
      variant="primary"
      size="sm"
      :disabled="terminated || validating || action.data.continue"
      @click="onContinueClick(action)"
    >
      {{ $t("action_plan.viewer.continue") }}
      <feather-icon icon="ChevronRightIcon" size="18"/>
    </b-button>
  </div>
</template>

<script>
import Files from "./Files.vue";

export default {
  components: {Files},
  props: {
    actionPlanLogUuid: String,
    action: Object,
    terminated: Boolean,
    preview: Boolean,
    validating: Boolean,
  },
  methods:{
    onContinueClick(action) {
      this.$emit("continue", action);
    },
  }
}
</script>
